import { SearchByQIDs } from '@exam-management/qbank-search-by-keywords';

export default function SearchByQIDsPage() {
  return <SearchByQIDs />;
}
